export const Mandate = () =>{
   return (<>
      <span className="error">*</span>
    </>);
}